export function HubNameData(listUserData, StatusData) {
  listUserData.forEach((data, i) => {
    let hubnames = JSON.parse(localStorage.getItem('hubList'));
    let hubZoneList = JSON.parse(localStorage.getItem('hubzoneList'));
    let hubZoneByHubId = JSON.parse(localStorage.getItem('hubzoneByHubId'));
    if (data.currenthubid !== null && data.currenthubid != undefined) {
      StatusData.forEach((x) => {
        if (x.stdstatusmasterid == data.status) {
          listUserData[i]["StatusName"] = x.statusname;
        }
      });
      listUserData[i]["currenthubName"] = hubnames[data.currenthubid];
      listUserData[i]["originhubName"] = hubnames[data.originhubid];
      listUserData[i]["damagehubName"] = hubnames[data.damagehub];
      listUserData[i]["ZoneID"] = hubZoneByHubId[data.currenthubid];
      listUserData[i]["ZoneName"] = hubZoneList[data.ZoneID];
    }
  });
  return listUserData

}
export function GetAllHubData(alldata) {
  let hubNameList = JSON.parse(localStorage.getItem('hubList'));
  let hubZoneList = JSON.parse(localStorage.getItem('hubzoneList'));
  let hubZoneByHubId = JSON.parse(localStorage.getItem('hubzoneByHubId'));
  let ReasonListdata = JSON.parse(localStorage.getItem('ReasonList'));
  let GetAllData = {}
  switch (alldata.damagecategory) {
    case "1":
      GetAllData.damagecategoryName = "Liquid spillage";
      break;
    case "2":
      GetAllData.damagecategoryName = "STD";
      break;
    case "3":
      GetAllData.damagecategoryName = "MPS Damaged";
      break;
    default:
      GetAllData.damagecategoryName = " ";
      break;
  }
  GetAllData.ReasonName = ReasonListdata[alldata.damagereason];
  GetAllData.ZoneID = hubZoneByHubId[alldata.currenthubid];
  GetAllData.ZoneName = hubZoneList[GetAllData.ZoneID];
  GetAllData.currentHubName = hubNameList[alldata.currenthubid];
  GetAllData.originHubName = hubNameList[alldata.originhubid];
  GetAllData.DamageZoneName = hubZoneList[alldata.damagezone];
  GetAllData.DamageHubName = hubNameList[alldata.damagehub];
  return GetAllData
}
export function getHubList(id) {
  let accesszonelist = window.localStorage.getItem('accesszone');
  let parsedata = JSON.parse(accesszonelist);
  let finalhublist = []
  parsedata.hubaccess.forEach((ele, i) => {
    if (id == parsedata.hubaccess[i]["HubZoneId"]) {

      finalhublist.push({
        id: parsedata.hubaccess[i]["HubID"],
        label: parsedata.hubaccess[i]["HubName"]
      })

    }
  })
  return finalhublist;
}
export function hubZoneDropDown() {
  let hubZoneList = Object.values(JSON.parse(localStorage.getItem('hubzoneList')));
  let finalDrop = [];
  hubZoneList.forEach((ele, i) => {
    finalDrop.push({
      id: i,
      label: ele
    });
  })
  return finalDrop;

}
export function hubDropDown() {
  let hubZoneList = Object.values(JSON.parse(localStorage.getItem('hubList')));
  let finalDrop = [];
  hubZoneList.forEach((ele, i) => {
    finalDrop.push({
      id: i,
      label: ele
    });
  })
  return finalDrop;

}




// WEBPACK FOOTER //
// ./src/services/B2BModule/CommonFuntion.js